// Make interface?
export class CoordsModel {

    latitude: number;
    longitude: number;

    constructor(lat?: number, lng?: number) {

        if (lat) {
            this.latitude = lat;
        }

        if (lng) {
            this.longitude = lng;
        }
    }
}
